import { render, staticRenderFns } from "./blocoInput.vue?vue&type=template&id=3aa0c7dd&"
import script from "./blocoInput.vue?vue&type=script&lang=js&"
export * from "./blocoInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports